import React, { useContext } from "react";
import { PAGE_MATCHED } from "../../utils/constant";
import CMSPageResourceList from "../../pages/cms/cpd/page.list";
import PageHeader from "./page.header";
import { PageContext } from "./page";
import UserManagementPage from "../../pages/admin/users/";

const PageToolbar = ({ ...props }) => {
  return <div>{props.children}</div>;
};

export const PageViewPartial = ({ ...props }) => {
  return <div>{props.children}</div>;
};

export const PageToobarFactory = ({
  toolBarLanding: LandingPageToolBar,
  toolBarDetails: DetailsPageToolBar,
  toolBarNew: NewPageToolBar,
  pageView,
  children,
}) => {
  switch (pageView) {
    case PAGE_MATCHED.LANDING_VIEW:
      return (
        <React.Fragment>
          <PageToolbar>
            <LandingPageToolBar />
          </PageToolbar>
          {children}
        </React.Fragment>
      );
    case PAGE_MATCHED.DETAILS_VIEW:
      return (
        <React.Fragment>
          <PageToolbar>
            <DetailsPageToolBar />
          </PageToolbar>
          {children}
        </React.Fragment>
      );
    case PAGE_MATCHED.EDIT_VIEW:
      return (
        <React.Fragment>
          <PageToolbar>
            <NewPageToolBar />
          </PageToolbar>
          {children}
        </React.Fragment>
      );
    case PAGE_MATCHED.CREATE_NEW_VIEW:
      return (
        <React.Fragment>
          <PageToolbar>
            <NewPageToolBar />
          </PageToolbar>
          {children}
        </React.Fragment>
      );
    default:
      return <React.Fragment>Unknown page toolbar fragment</React.Fragment>;
  }
};

const PageFactory = ({
  toolBar: ToolbarFactory,
  pageView,
  resource,
  resources,
  loading,
  setLoading,
  pathname,
  children,
}) => {
  const { headerText } = useContext(PageContext);

  switch (resource) {
    case "users":
      return (
        <React.Fragment>
          <ToolbarFactory />
          {pageView === PAGE_MATCHED.LANDING_VIEW && (
            <UserManagementPage
              pathname={pathname}
              resource={resource}
              loading={loading}
              resources={resources}
            />
          )}
          {pageView === PAGE_MATCHED.DETAILS_VIEW && <>{children}</>}
          {pageView === PAGE_MATCHED.CREATE_NEW_VIEW && <>{children}</>}
          {pageView === PAGE_MATCHED.EDIT_VIEW && <>{children}</>}
        </React.Fragment>
      );
    case "cases":
      return (
        <React.Fragment>
          <ToolbarFactory />
          {pageView === PAGE_MATCHED.LANDING_VIEW && (
            <CMSPageResourceList
              pathname={pathname}
              resource={resource}
              loading={loading}
            />
          )}
          {pageView === PAGE_MATCHED.DETAILS_VIEW && (
            <>
              <PageHeader headerText={headerText} />
              {children}
            </>
          )}
          {pageView === PAGE_MATCHED.CREATE_NEW_VIEW && <>{children}</>}
        </React.Fragment>
      );
    case "nodes":
      return (
        <React.Fragment>
          <ToolbarFactory />
          {pageView === PAGE_MATCHED.LANDING_VIEW && (
            <CMSPageResourceList
              pathname={pathname}
              resource={resource}
              loading={loading}
            />
          )}
          {pageView === PAGE_MATCHED.DETAILS_VIEW && (
            <>
              <PageHeader headerText={headerText} />
              {children}
            </>
          )}
          {pageView === PAGE_MATCHED.CREATE_NEW_VIEW && <>{children}</>}
        </React.Fragment>
      );
    case "guidelines":
    case "courses":
    case "conditions":
      return (
        <React.Fragment>
          <ToolbarFactory />
          {pageView === PAGE_MATCHED.LANDING_VIEW && (
            <CMSPageResourceList
              pathname={pathname}
              resource={resource}
              loading={loading}
            />
          )}
          {pageView === PAGE_MATCHED.DETAILS_VIEW && (
            <>
              <PageHeader headerText={headerText} />
              {children}
            </>
          )}
          {pageView === PAGE_MATCHED.CREATE_NEW_VIEW && <>{children}</>}
        </React.Fragment>
      );
    default:
      return <React.Fragment>Unknown page fragment</React.Fragment>;
  }
};

export default PageFactory;
